import {Card} from 'react-bootstrap';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import TrendingMovies from '../Components/TrendingMovies';
import TrendingSeries from '../Components/TrendingSeries';
const axios = require('axios');


function Home() { 
    return (
        <div>
            <h1 className="pageTitle">Trending movies</h1>
            <TrendingMovies />
            <h1 className="pageTitle">Trending series</h1>
            <TrendingSeries />
        </div>
    );
}

export default Home;

